




import { defineComponent } from '@vue/composition-api';

const Index = defineComponent({
  // setup() {},
  props: {
    role: {},
  },
});

export default Index;
